
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ec2ac125f43e76c6186cfa533094066.jpg"
          alt="Secure Healthcare Technology"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d1117]/95 via-[#1a2332]/90 to-[#1a2332]/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="max-w-4xl">
          <div className="text-[#e10708] text-3xl font-bold mb-6 tracking-wide uppercase">
            IT Solutions for Healthcare
          </div>
          <h1 className="text-6xl lg:text-7xl font-bold leading-tight mb-6">
            <span className="text-white">You Focus on the Patient. We Protect the Practice.</span>
          </h1>
          <p className="text-xl lg:text-2xl text-gray-300 mb-12 leading-relaxed font-light">
            Total Technology Oversight, Cybersecurity, and HIPAA Governance for Modern Healthcare.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link
              to="/contact"
              className="bg-[#e10708] text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-[#c00607] transition-all duration-300 shadow-2xl hover:shadow-[#e10708]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Schedule Risk Assessment
            </Link>
            <a
              href="#problems"
              className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </a>
          </div>
          <div className="mt-12 flex items-center gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-[#e10708] text-lg"></i>
              <span>HIPAA-Certified</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
